import { ReactComponent as CarWithParkSign } from "assets/icons/car-with-park-sign.svg";
import { ReactComponent as DoubleBalloons } from "assets/icons/double-balloons.svg";
import { ReactComponent as parkingSign } from "assets/icons/parking-sign.svg";
import { ReactComponent as Phone } from "assets/icons/phone.svg";
import { ReactComponent as Warning } from "assets/icons/warning.svg";
import { ReactComponent as QuestionBalloon } from "assets/icons/question-balloon.svg";
import { ReactComponent as InfoBalloon } from "assets/icons/info-balloon.svg";
import { ReactComponent as BackArrow } from "assets/icons/back-arrow.svg";
import { ReactComponent as Close } from "assets/icons/close.svg";
import { ReactComponent as DataRede } from "assets/icons/data-rede.svg";
import { ReactComponent as DownArrow } from "assets/icons/down-arrow.svg";
import { ReactComponent as FrontArrow } from "assets/icons/front-arrow.svg";
import { ReactComponent as OutlinedCorrect } from "assets/icons/outlined-correct.svg";
import { ReactComponent as OutlinedCross } from "assets/icons/outlined-cross.svg";
import { ReactComponent as Paper } from "assets/icons/paper.svg";
import { ReactComponent as PermitHolder } from "assets/icons/permit-holder.svg";
import { ReactComponent as Pin } from "assets/icons/pin.svg";
import { ReactComponent as WarningBalloon } from "assets/icons/warning-balloon.svg";
import { ReactComponent as MapPinArea } from "assets/icons/map-pin-area.svg";

export type IconType =
  | "carWithParkSign"
  | "doubleBalloons"
  | "parkingSign"
  | "phone"
  | "warning"
  | "questionBalloon"
  | "infoBalloon"
  | "backArrow"
  | "close"
  | "dataRede"
  | "downArrow"
  | "frontArrow"
  | "outlinedCorrect"
  | "outlinedCross"
  | "paper"
  | "permitHolder"
  | "pin"
  | "warningBalloon"
  | "mapPinArea";

export const Icons: Record<
  IconType,
  React.FunctionComponent<React.SVGProps<SVGSVGElement>>
> = {
  carWithParkSign: CarWithParkSign,
  doubleBalloons: DoubleBalloons,
  parkingSign: parkingSign,
  phone: Phone,
  warning: Warning,
  questionBalloon: QuestionBalloon,
  infoBalloon: InfoBalloon,
  backArrow: BackArrow,
  close: Close,
  dataRede: DataRede,
  downArrow: DownArrow,
  frontArrow: FrontArrow,
  outlinedCorrect: OutlinedCorrect,
  outlinedCross: OutlinedCross,
  paper: Paper,
  permitHolder: PermitHolder,
  pin: Pin,
  warningBalloon: WarningBalloon,
  mapPinArea: MapPinArea,
};
